<template>
  <div class="ticket-pooq">
    <div class="ticket-pooq-top" :class="+productGroups.concurrency_count <= 1 ? 'no-same-time-wrap' : ''">
      <p :style="'color: ' + productGroups.color" class="ticket-btit">{{ productGroups.productgroup_name }}</p>
      <p class="ticket-sub-tit">{{ productGroups.description }}</p>
    </div>
    <movie-products :products="productGroups.products"
                    :max-user-count="+productGroups.concurrency_count"
                    :productColor="productGroups.color"
                    :voucher-type="voucherType"
                    :content-id="contentId"/>
  </div>
</template>

<script>
import MovieProducts from '@/components/play/bottom-tab/MovieProducts'

export default {
  components: {
    MovieProducts
  },
  props: {
    productGroups: {
      type: Object,
      required: true
    },
    categoryNum: {
      type: Number,
      required: true
    },
    productGroupNum: {
      type: Number,
      required: true
    },
    voucherType: {
      type: String,
      required: true
    },
    contentId: {
      type: String
    }
  }
}
</script>

<style lang="css">
.no-same-time-wrap {
  margin-bottom: 15px;
}
.ticket-pooq {
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 5px;
  position: relative;
}
.ticket-pooq-top {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.ticket-btit, .ticket-tit {
  letter-spacing: -.2px;
  margin-bottom: 5px;
}
.ticket-btit {
  font-weight: 700;
  font-size: 15px;
}
.ticket-sub-tit {
  font-size: 12px;
  color: #777;
  margin-bottom: 5px;
  background-color: #fff;
  opacity: 0.9;
}
</style>
